import { React, useState } from 'react';
import ReactECharts from 'echarts-for-react';  // or var ReactECharts = require('echarts-for-react');
import TripPopup from 'components/trip_and_charge_component/TripPopup';
import * as echarts from 'echarts';
import moment from 'moment';
// Import the echarts core module, which provides the necessary interfaces for using echarts.
// import * as echarts from 'echarts/core';
// Import charts, all with Chart suffix
import {
  // LineChart,
  // BarChart,
  // PieChart,
  // ScatterChart,
  // RadarChart,
  // MapChart,
  // TreeChart,
  // TreemapChart,
  // GraphChart,
  // GaugeChart,
  // FunnelChart,
  // ParallelChart,
  // SankeyChart,
  // BoxplotChart,
  // CandlestickChart,
  // EffectScatterChart,
  // LinesChart,
  // HeatmapChart,
  // PictorialBarChart,
  // ThemeRiverChart,
  // SunburstChart,
  CustomChart,
} from 'echarts/charts';
// import components, all suffixed with Component
import {
  // GridSimpleComponent,
  GridComponent,
  // PolarComponent,
  // RadarComponent,
  // GeoComponent,
  // SingleAxisComponent,
  // ParallelComponent,
  // CalendarComponent,
  // GraphicComponent,
  ToolboxComponent,
  TooltipComponent,
  // AxisPointerComponent,
  // BrushComponent,
  TitleComponent,
  // TimelineComponent,
  // MarkPointComponent,
  // MarkLineComponent,
  // MarkAreaComponent,
  // LegendComponent,
  // LegendScrollComponent,
  // LegendPlainComponent,
  DataZoomComponent,
  DataZoomInsideComponent,
  DataZoomSliderComponent,
  // VisualMapComponent,
  // VisualMapContinuousComponent,
  // VisualMapPiecewiseComponent,
  // AriaComponent,
  // TransformComponent,
  // DatasetComponent,
} from 'echarts/components';
// Import renderer, note that introducing the CanvasRenderer or SVGRenderer is a required step
import {
  CanvasRenderer,
  // SVGRenderer,
} from 'echarts/renderers';
import { useAbsoluteLayout } from 'react-table';


// var option;
// var vehicleId= 0;
var scheduleid = 0;
// var make =1;
// var model =2;
var startTime = 1;
var endTime = 2;
var name = 3;
var HEIGHT_RATIO = 0.3;
var _draggable;
// var HEIGHT_RATIO = 0.6;
// var DIM_CATEGORY_INDEX = 0;
// var DIM_TIME_ARRIVAL = 1;
// var DIM_TIME_DEPARTURE = 2;
// var DATA_ZOOM_AUTO_MOVE_THROTTLE = 30;
// var DATA_ZOOM_X_INSIDE_INDEX = 1;
// var DATA_ZOOM_Y_INSIDE_INDEX = 3;
// var DATA_ZOOM_AUTO_MOVE_SPEED = 0.2;
// var DATA_ZOOM_AUTO_MOVE_DETECT_AREA_WIDTH = 30;
// var _draggable = true;
// var _draggingEl;
// var _dropShadow;
// var _draggingCursorOffset = [0, 0];
// var _draggingTimeLength;
// var _draggingRecord;
// var _dropRecord;
// var _cartesianXBounds = [];
// var _cartesianYBounds = [];
// var _autoDataZoomAnimator;

var rawData = {
  "vehicleList": {
    "dimensions": [
      "id",
      "make",
      "model"
    ],
    "data": [

      [
        1,
        "BB-01",
        "BlueBird D"
      ],
      [
        2,
        "BB-02",
        "BlueBird D"
      ],
      [
        3,
        "BB-03",
        "BlueBird c"
      ],
      [
        4,
        "BB-04",
        "BlueBird D"
      ],
      [
        5,
        "BB-05",
        "BlueBird D"
      ],
      [
        6,
        "BB-06",
        "BlueBird D"

      ],
      [
        7,
        "Li-01",
        "Lion C"
      ],
      [
        8,
        "Li-02",
        "Lion C"
      ],
      [
        9,
        "Li-03",
        "Lion C"
      ],
      [
        10,
        "make",
        "model"
      ],
      [
        11,
        "Li-01",
        "Lion C"
      ],
      [
        12,
        "make",
        "model"
      ],
      [
        13,
        "make",
        "model"
      ],
      [
        14,
        "make",
        "model"
      ],
      [
        15,
        "make",
        "model"
      ],
      [
        16,
        "make",
        "model"
      ],
      [
        17,
        "make",
        "model"
      ],
      [
        18,
        "make",
        "model"
      ],
      [
        19,
        "make",
        "model"
      ],
      [
        20,
        "make",
        "model"
      ],
      [
        21,
        "make",
        "model"
      ],
      [
        84,
        "make",
        "model"
      ]

    ]

  },
  "vehicleSchedule": {
    "dimensions": [
      "id",
      "scheduleStart",
      "scheduleEnd",
      "name"
    ],
     "data": [

      [
        0,
        1496904900000,
        1496924700000,
        "M766OG"
      ],
      [
        0,
        1496840400000,
        1496934000000,
        "Y3683"
      ],
      [
        1,//179
        1496924700000,
        1496934000000,
        "Y4897"
      ],
      [
        1,//179
        1496840400000,
        1496878800000,
        "Y4893"
      ],
      [
        2,
        1496916600000,
        1496934000000,
        "Y3193"
      ],
      [
        2,
        1496840400000,
        1496934000000,
        "Y3683"
      ],
      [
        3,
        1496914200000,
        1496934000000,
        "Y4890"
      ],
      [
        3,
        1496840400000,
        1496882400000,
        "Y3846"
      ],
      [
        4,
        1496907300000,
        1496934000000,
        "Y4328"
      ],
      [
        4,
        1496840400000,
        1496875800000,
        "Y1334"
      ],
      [
        5,
        1496913600000,
        1496934000000,
        "Y3703"
      ],
      [
        5,
        1496840400000,
        1496871900000,
        "Y8481"
      ],
      [
        6,
        1496901300000,
        1496934000000,
        "Y4896"
      ],
      [
        6,
        1496840400000,
        1496880600000,
        "Y4620"
      ],
      [
        7,
        1496920200000,
        1496934000000,
        "Y4223"
      ],
      [
        7,
        1496840000000,
        1496874600000,
        "Y4974"
      ],
      [
        8,
        1496922100000,
        1496934000000,
        "Y7649"
      ],
      [
        8,
        1496843400000,
        1496880000000,
        "Y8383"
      ],
      [
        9,
        1496927400000,
        1496934000000,
        "Y7606"
      ],
      [
        9,
        1496840400000,
        1496878200000,
        "Y7604"
      ],
      [
        10,
        1496874300000,
        1496934000000,
        "Y7391"
      ],
      [
        10,
        1496840400000,
        1496853000000,
        "Y7425"
      ],
      [
        11,
        1496903100000,
        1496911500000,
        "M149UW"
      ],
      [
        11,
        1496845800000,
        1496853000000,
        "M545KZ"
      ],
      [
        12,
        1496919600000,
        1496934000000,
        "Y3249"
      ],
      [
        12,
        1496850900000,
        1496870100000,
        "Y1353"
      ],
      [
        13,
        1496917200000,
        1496917800000,
        "YNSP"
      ],
      [
        13,
        1496907900000,
        1496908800000,
        "YNSR"
      ],
      [
        14,
        1496919300000,
        1496934000000,
        "Y3834"
      ],
      [
        14,
        1496840400000,
        1496877300000,
        "Y4301"
      ],
      [
        15,
        1496926200000,
        1496934000000,
        "Y4324"
      ],
      [
        15,
        1496844300000,
        1496866800000,
        "Y2112"
      ],
      [
        16,
        1496916600000,
        1496934000000,
        "Y7631"
      ],
      [
        16,
        1496843700000,
        1496875800000,
        "Y7603"
      ],
      [
        17,
        1496916300000,
        1496934000000,
        "Y3521"
      ],
      [
        17,
        1496840400000,
        1496874300000,
        "Y7630"
      ],
      [
        18,
        1496904900000,
        1496924700000,
        "Y4746"
      ],
      [
        18,
        1496840400000,
        1496882400000,
        "Y3016"
      ],
      [
        19,
        1496897700000,
        1496913900000,
        "Y3351"
      ],
      [
        19,
        1496840400000,
        1496872800000,
        "Y3370"
      ],
      [
        20,
        1496915400000,
        1496934000000,
        "Y4418"
      ],
      [
        20,
        1496894100000,
        1496909100000,
        "Y8006"
      ],
      [
        20,
        1496841600000,
        1496877300000,
        "Y8422"
      ],
      [
        21,
        1496925600000,
        1496934000000,
        "Y8497"
      ],
      [
        21,
        1496906100000,
        1496917800000,
        "Y3802"
      ],
      [
        21,
        1496840400000,
        1496881800000,
        "Y1832"
      ]



    ]

  },
  "chargerList": {
    "dimensions": [
      "id",
      "make",
      "model"
    ],
    "data": [

      [
        298,
        "USD-1",
        "PowerPort 19kw"
      ],
      [
        178,
        "USD-2",
        "PowerPort 19kw"
      ],
      [
        96,
        "USD-3",
        "PowerPort 19kw"
      ],
      [
        90,
        "USD-4",
        "PowerPort 19kw"
      ],
      [
        86,
        "USD-5",
        "PowerPort 19kw"
      ],
      [
        272,
        "USD-6",
        "PowerPort 19kw"

      ],
      [
        281,
        "USD-7",
        "PowerPort 19kw"
      ],
      [
        175,
        "USD-8",
        "PowerPort 19kw"
      ],
      [
        99,
        "USD-9",
        "PowerPort 19kw"
      ],
      [
        202,
        "USD-10",
        "PowerPort 19kw"
      ],
      [
        46,
        "USD-11",
        "PowerPort 19kw"
      ],
      [
        261,
        "USD-12",
        "PowerPort 19kw"
      ],
      [
        183,
        "USD-13",
        "PowerPort 19kw"
      ],
      [
        303,
        "USD-14",
        "PowerPort 19kw"
      ],
      [
        267,
        "USD-15",
        "PowerPort 19kw"
      ],
      [
        123,
        "USD-16",
        "PowerPort 19kw"
      ],
      [
        59,
        "USD-17",
        "PowerPort 19kw"
      ],
      [
        168,
        "USD-18",
        "PowerPort 19kw"
      ],
      [
        200,
        "USD-19",
        "PowerPort 19kw"
      ],
      [
        263,
        "USD-20",
        "PowerPort 19kw"
      ],
      [
        85,
        "USD-21",
        "PowerPort 19kw"
      ],
      [
        84,
        "USD-22",
        "PowerPort 19kw"
      ]

    ]

  },
  "chargerSchedule": {
    "dimensions": [
      "id",
      "scheduleStart",
      "scheduleEnd",
      "name"
    ],
    "data": [

      [
        0,
        1496904900000,
        1496924700000,
        "M766OG"
      ],
      [
        0,
        1496840400000,
        1496934000000,
        "Y3683"
      ],
      [
        1,//179
        1496924700000,
        1496934000000,
        "Y4897"
      ],
      [
        1,//179
        1496840400000,
        1496878800000,
        "Y4893"
      ],
      [
        2,
        1496916600000,
        1496934000000,
        "Y3193"
      ],
      [
        2,
        1496840400000,
        1496934000000,
        "Y3683"
      ],
      [
        3,
        1496914200000,
        1496934000000,
        "Y4890"
      ],
      [
        3,
        1496840400000,
        1496882400000,
        "Y3846"
      ],
      [
        4,
        1496907300000,
        1496934000000,
        "Y4328"
      ],
      [
        4,
        1496840400000,
        1496875800000,
        "Y1334"
      ],
      [
        5,
        1496913600000,
        1496934000000,
        "Y3703"
      ],
      [
        5,
        1496840400000,
        1496871900000,
        "Y8481"
      ],
      [
        6,
        1496901300000,
        1496934000000,
        "Y4896"
      ],
      [
        6,
        1496840400000,
        1496880600000,
        "Y4620"
      ],
      [
        7,
        1496920200000,
        1496934000000,
        "Y4223"
      ],
      [
        7,
        1496840000000,
        1496874600000,
        "Y4974"
      ],
      [
        8,
        1496922100000,
        1496934000000,
        "Y7649"
      ],
      [
        8,
        1496843400000,
        1496880000000,
        "Y8383"
      ],
      [
        9,
        1496927400000,
        1496934000000,
        "Y7606"
      ],
      [
        9,
        1496840400000,
        1496878200000,
        "Y7604"
      ],
      [
        10,
        1496874300000,
        1496934000000,
        "Y7391"
      ],
      [
        10,
        1496840400000,
        1496853000000,
        "Y7425"
      ],
      [
        11,
        1496903100000,
        1496911500000,
        "M149UW"
      ],
      [
        11,
        1496845800000,
        1496853000000,
        "M545KZ"
      ],
      [
        12,
        1496919600000,
        1496934000000,
        "Y3249"
      ],
      [
        12,
        1496850900000,
        1496870100000,
        "Y1353"
      ],
      [
        13,
        1496917200000,
        1496917800000,
        "YNSP"
      ],
      [
        13,
        1496907900000,
        1496908800000,
        "YNSR"
      ],
      [
        14,
        1496919300000,
        1496934000000,
        "Y3834"
      ],
      [
        14,
        1496840400000,
        1496877300000,
        "Y4301"
      ],
      [
        15,
        1496926200000,
        1496934000000,
        "Y4324"
      ],
      [
        15,
        1496844300000,
        1496866800000,
        "Y2112"
      ],
      [
        16,
        1496916600000,
        1496934000000,
        "Y7631"
      ],
      [
        16,
        1496843700000,
        1496875800000,
        "Y7603"
      ],
      [
        17,
        1496916300000,
        1496934000000,
        "Y3521"
      ],
      [
        17,
        1496840400000,
        1496874300000,
        "Y7630"
      ],
      [
        18,
        1496904900000,
        1496924700000,
        "Y4746"
      ],
      [
        18,
        1496840400000,
        1496882400000,
        "Y3016"
      ],
      [
        19,
        1496897700000,
        1496913900000,
        "Y3351"
      ],
      [
        19,
        1496840400000,
        1496872800000,
        "Y3370"
      ],
      [
        20,
        1496915400000,
        1496934000000,
        "Y4418"
      ],
      [
        20,
        1496894100000,
        1496909100000,
        "Y8006"
      ],
      [
        20,
        1496841600000,
        1496877300000,
        "Y8422"
      ],
      [
        21,
        1496925600000,
        1496934000000,
        "Y8497"
      ],
      [
        21,
        1496906100000,
        1496917800000,
        "Y3802"
      ],
      [
        21,
        1496840400000,
        1496881800000,
        "Y1832"
      ]



    ]

  }
};

function onDragSwitchClick(model, api, type) {
  _draggable = !_draggable;
  CustomChart.setOption({
    dataZoom: [{
      id: 'insideX',
      disabled: _draggable
    },

      // , {
      //     id: 'insideY',
      //     disabled: _draggable
      // }
    ]
  });
  this.model.setIconStatus(type, _draggable ? 'emphasis' : 'normal');
}
var day;
var tripSchedule;
const ViewGantt = (props) => {
  // Register the required components
  echarts.registerTheme('my_theme', {
    backgroundColor: '#f4cccc'
  });

  day = props.day;
  tripSchedule = props.chargerTripShedule
  
  echarts.use(
    [ToolboxComponent, TitleComponent, TooltipComponent, GridComponent, CustomChart, CanvasRenderer, DataZoomComponent, DataZoomInsideComponent, DataZoomSliderComponent]
  );

  const options = () => (
    {
      tooltip: {
        show: false
      },
      animation: false,
      toolbox: {
        left: 20,
        top: 0,
        itemSize: 20,
        // feature: {
        //     myDrag: {
        //         show: true,
        //         title: 'Make bars\ndraggable',
        //         // icon: 'path://M990.55 380.08 q11.69 0 19.88 8.19 q7.02 7.01 7.02 18.71 l0 480.65 q-1.17 43.27 -29.83 71.93 q-28.65 28.65 -71.92 29.82 l-813.96 0 q-43.27 -1.17 -72.5 -30.41 q-28.07 -28.07 -29.24 -71.34 l0 -785.89 q1.17 -43.27 29.24 -72.5 q29.23 -29.24 72.5 -29.24 l522.76 0 q11.7 0 18.71 7.02 q8.19 8.18 8.19 18.71 q0 11.69 -7.6 19.29 q-7.6 7.61 -19.3 7.61 l-518.08 0 q-22.22 1.17 -37.42 16.37 q-15.2 15.2 -15.2 37.42 l0 775.37 q0 23.39 15.2 38.59 q15.2 15.2 37.42 15.2 l804.6 0 q22.22 0 37.43 -15.2 q15.2 -15.2 16.37 -38.59 l0 -474.81 q0 -11.7 7.02 -18.71 q8.18 -8.19 18.71 -8.19 l0 0 ZM493.52 723.91 l-170.74 -170.75 l509.89 -509.89 q23.39 -23.39 56.13 -21.05 q32.75 1.17 59.65 26.9 l47.94 47.95 q25.73 26.89 27.49 59.64 q1.75 32.75 -21.64 57.3 l-508.72 509.9 l0 0 ZM870.09 80.69 l-56.13 56.14 l94.72 95.9 l56.14 -57.31 q8.19 -9.35 8.19 -21.05 q-1.17 -12.86 -10.53 -22.22 l-47.95 -49.12 q-10.52 -9.35 -23.39 -9.35 q-11.69 -1.17 -21.05 7.01 l0 0 ZM867.75 272.49 l-93.56 -95.9 l-380.08 380.08 l94.73 94.73 l378.91 -378.91 l0 0 ZM322.78 553.16 l38.59 39.77 l-33.92 125.13 l125.14 -33.92 l38.59 38.6 l-191.79 52.62 q-5.85 1.17 -12.28 0 q-6.44 -1.17 -11.11 -5.84 q-4.68 -4.68 -5.85 -11.7 q-2.34 -5.85 0 -11.69 l52.63 -192.97 l0 0 Z',
        //          onclick: onDragSwitchClick
        //     }
        // }

      },
      title: {
        show: false,
        text: 'Gantt of vehicle list',
        left: 'center'
      },
      dataZoom: [

        {
          type: 'slider',
          yAxisIndex: 0,
          zoomLock: true,
          width: 0,
          right: 4,
          top: 60,
          bottom: 20,
          start: 0,
          end: 35,
          handleSize: 0,
          showDetail: false,
        },
        {
          type: 'inside',
          id: 'insideY',
          yAxisIndex: 0,
          width: 10,
          top:59,
          start: 0,
          end: 35,
          zoomOnMouseWheel: false,
          moveOnMouseMove: true,
          moveOnMouseWheel: true
        }
      ],
      grid: {
        top: 59,
        bottom: 20,
        // left:350,
        left:window.screen.width >=1920? props.chargerTripShedule === 'Trip Schedule' ? (day === 6 ? 350 : day === 5 ? 302 : day === 4 ? 265 : day === 3 ? 230 : day === 2 ? 195 : day === 1 ? 152 : 132) :
          (day === 6 ? 375 : day === 5 ? 332 : day === 4 ? 275 : day === 3 ? 255 : day === 2 ? 225 : day === 1 ? 182 : 158):
          props.chargerTripShedule === 'Trip Schedule' ? (day === 6 ? 250 : day === 5 ? 220 : day === 4 ? 190 : day === 3 ? 165 : day === 2 ? 140 : day === 1 ? 115 : 100) :
          (day === 6 ? 260 : day === 5 ? 240 : day === 4 ? 204 : day === 3 ? 188 : day === 2 ? 163 : day === 1 ? 137 : 110),
        right: 10,
        backgroundColor: '#fff',
        borderWidth: 0
      },
      xAxis: {
        type: 'time',
        position: 'top',
        // boundaryGap: [props.gap+'%', '0%'],
        boundaryGap:window.screen.width >=1920? (props.chargerTripShedule === 'Trip Schedule' ? ['1%', '.5%'] : ['1.2%', '.5%']):
        (props.chargerTripShedule === 'Trip Schedule' ? ['1%', '1.5%'] : ['1.2%', '1.5%']),
        splitLine: {
          lineStyle: {
            color: ['#E9EDFF']
          },
        },
        axisLine: {
          show: true,
        },
        axisTick: {
          show: true,
          lineStyle: {
            // color: '#929ABA'
            color: '#929ABA'
          },
          inside: true,
        },
        axisLabel: {
          color: '#000000',
          inside: true,
          align: 'center',
              formatter: (function(value){
              return moment(value).format('hh:mm a');
            })
        },
        minInterval: 3600 * 1000 * 3,
        maxInterval: 3600 * 1000 * 3 ,
        interval: 3600 * 1000 * 3,
      },
      yAxis: {
        axisTick: { show: false },
        // splitLine: {show: true},
        axisLine: { show: false },
        boundaryGap: ['3%', '2%'],
        // axisLabel: {show: false},
        min: 0,
        type: 'value',
        axisLabel: {
          show: false,
          formatter: '{value} °C'
        },
        // name: 'Y-Axis',
        // nameLocation: 'middle',
        // nameGap: 50,
        max: rawData.vehicleList.data.length,
        // nameGap:200
      },
      series: [{
        id: 'flightData',
        type: 'custom',
        renderItem: renderGanttItem,
        dimensions: props.chargerTripShedule === 'Trip Schedule' ? rawData.vehicleSchedule.dimensions : rawData.chargerSchedule.dimensions,
        encode: {
          x: [startTime, endTime],
          y: scheduleid,
          tooltip: [name, startTime, endTime]
        },
        data: props.chargerTripShedule === 'Trip Schedule' ? rawData.vehicleSchedule.data : rawData.chargerSchedule.data
      }, {
        type: 'custom',
        renderItem: renderAxisLabelItem1,
        dimensions: props.chargerTripShedule === 'Trip Schedule' ? rawData.vehicleList.dimensions : rawData.chargerList.dimensions,
        encode: {
          x: 0, // Then this series will not controlled by x.
          y: 0
        },
        data: echarts.util.map(props.chargerTripShedule === 'Trip Schedule' ? rawData.vehicleList.data : rawData.chargerList.data, function (item, index) {
          return [index].concat(item);
          
        })
      }]
    }
  );

  function renderGanttItem(params, api) {
    var categoryIndex = api.value(scheduleid);
    var timeArrival = api.coord([api.value(startTime), categoryIndex]);
    var timeDeparture = api.coord([api.value(endTime), categoryIndex]);
    var barLength = timeDeparture[0] - timeArrival[0];
    // Get the heigth corresponds to length 1 on y axis.
    var barHeight = api.size([0, 1])[1] * HEIGHT_RATIO;
    var x = timeArrival[0];
    var y = timeArrival[1] - barHeight;

    var flightNumber = api.value(3) + '';
    var flightNumberWidth = echarts.format.getTextRect(flightNumber).width;
    var text = (barLength > flightNumberWidth + 40 && x + barLength >= 180)
      ? flightNumber : '';

    var rectNormal = clipRectByRect(params, {
      x: x, y: y, width: barLength, height: barHeight,

    });
    // var rectVIP = clipRectByRect(params, {
    //     x: x, y: y, width: (barLength) / 2, height: barHeight
    // });
    var rectText = clipRectByRect(params, {
      x: x, y: y, width: barLength, height: barHeight
    });

    function clipRectByRect(params, rect) {
      return echarts.graphic.clipRectByRect(rect, {
        x: params.coordSys.x,
        y: params.coordSys.y,
        // r: [5,5,5,5],
        width: params.coordSys.width,
        height: params.coordSys.height,
        r:[5,5,5,5],
      });
    }

    return {
      type: 'group',
      children: [{
        type: 'rect',
        ignore: !rectNormal,
        // shape:rectNormal,
        shape: {
          x: x, y: y, width: barLength, height: barHeight,
          r:[5,5,5,5],
        },
        style: api.style({
          // fill: '#FC9B9B',
          fill: props.chargerTripShedule === 'Trip Schedule' ? '#FC9B9B' : "#9B9FFC",
          borderColor: '#f0f',
        })
      },
      // {
      //     type: 'rect',
      //     ignore: !rectVIP && !api.value(4),
      //     shape: rectVIP,
      //     style: api.style({fill: '#ddb30b'})
      // }, 
      {
        type: 'rect',
        ignore: !rectText,
        shape: rectText,
        style: api.style({
          fill: 'transparent',
          stroke: 'transparent',
          text: text,
          textFill: '#fff'
        })
      }
      ]
    };
  }
//   const [chartPopupData, setChartPopupData] = useState(true)
//   const onChartClick = (params) => {
//     let dataVal = {
//       dataVa: params.data,
//       stateP: chartPopupData
//     }

//     props.popupCallBack(dataVal)
//   };

//   const onEvents = {
//     click: onChartClick
//   }


  return (

    <ReactECharts
      // ref="chinaMapChart"
      echarts={echarts}
      //option={this.getOption()}
      // notMerge={true}
      // lazyUpdate={true}

      theme={"theme_name"}
      //onChartReady={this.onChartReadyCallback}
      //onEvents={EventsDict}
      style={{
        height: '100%',
        width: '100%',
      }}
      // opts={{renderer: 'svg'}} // use svg to render the chart.
    //   onEvents={onEvents}
      option={options(

      )}
    />

  )

};


function renderAxisLabelItem1(params, api) {

  var y = api.coord([0, api.value(0)])[1];
  if (y < params.coordSys.y + 5) {
    return;
  }
 
  return {

    type: 'group',
    position: [
      0,
      y
    ],
    children: [
      {
        type: 'path',
        shape: {
          // d: " M 2,2 L 20,0 Z",
          d: 'M0,0 L0,-20 L30,-20 C40,-20 40,-1 50,-1 L90,-1 L90,0 Z',
          // d: 'M0,0 L0,-0.09 L390,-0.09 L390,0 Z',
          // d: 'M1,1  L1,0    Z',
          x: 0,
          y: 0,
          width:window.screen.width >=1920? (tripSchedule === 'Trip Schedule' ? (day === 6 ? 1305 + (day * 33) : day === 5 ? 1425 + (day * 31) : day === 4 ? 1425 + (day * 30) : day === 3 ? 1425 + (day * 27) : day === 2 ? 1425 + (day * 22) : day === 1 ? 1425 + (day * 9) : day === 0 ? 1395 + (day * 1) : 1425 + (day * 0))
            : (day === 6 ? 1450 + (day * 33) : day === 5 ? 1420 + (day * 31) : day === 4 ? 1400 + (day * 30) : day === 3 ? 1400 + (day * 27) : day === 2 ? 1400 + (day * 22) : day === 1 ? 1400 + (day * 9) : day === 0 ? 1350 + (day * 1) : 1425 + (day * 0))):
           (tripSchedule === 'Trip Schedule' ? (day === 6 ? 912 + (day * 33) : day === 5 ? 932 + (day * 31) : day === 4 ? 940 + (day * 30) : day === 3 ? 954 + (day * 27) : day === 2 ? 965 + (day * 22) : day === 1 ? 972 + (day * 9) : day === 0 ? 955 + (day * 1) : 912 + (day * 0))
            : (day === 6 ? 936 + (day * 33) : day === 5 ? 955 + (day * 31) : day === 4 ? 952 + (day * 30) : day === 3 ? 965 + (day * 27) : day === 2 ? 975 + (day * 22) : day === 1 ? 985 + (day * 9) : day === 0 ? 968 + (day * 1) : 952 + (day * 0))),
          // width: 1750, //todo make with dynamic 
          height: 1,
          right: 0,
          layout: 'cover'
        },
        style: {
          fill: '#fff',
          strokeWidth: '1px',
          stroke: '#CCCCCC',

        }
      },
      {
        type: 'text',
        style: {
          x: tripSchedule === 'Trip Schedule' ? 5 : 0,
          y: -16,
          text: api.value(2),
          textVerticalAlign: 'bottom',
          textAlign: 'left',
          textFill: '#000',
          fontSize: 13,
          fontFamily: "Montserrat"
        }
      }, {
        type: 'text',
        style: {
          x: tripSchedule === 'Trip Schedule' ? 5 : 0,
          y: 0,
          position: "absolute",
          text: api.value(3),
          textVerticalAlign: 'bottom',
          textAlign: 'left',
          textFill: '#696969',
          fontSize: 13,
          fontFamily: "Montserrat",
          zIndex: 60,
        }
      }
      // , {
      //     type: 'text',
      //     style: {
      //         x: 75,
      //         y: -2,
      //         textVerticalAlign: 'bottom',
      //         textAlign: 'center',
      //         text: api.value(2),
      //         textFill: '#000'
      //     }
      // }
    ]
  };
}

export default ViewGantt;


